angular.module('eficienciaFiscalModule')
    .component('operationsToolbar', {
        transclude: true,
        transclude: {
            left: '?left',
            right: '?right'
        },
        template: `
            <div style="margin: -13px -13px 15px -13px; background-color: #ffffff; border-bottom: 1px solid #cccccc;
                        box-shadow: 0 1px 7px -4px #000; padding: 5px;">
                <div style="display: flex; justify-content: space-between;">
                    <div ng-transclude="left"></div>
                    <div ng-transclude="right"></div>
                </div>
            </div>
        `
    })
